const getToast = () => {
  const el = document.querySelector('ds-toast');
  if (!el)
    throw new Error('<ds-toast /> is not loaded');
  return el;
};
const notify = (messageTitle, messageContent, level, userDismissOrTimeOut) => {
  return getToast().notify(messageTitle, messageContent, level, userDismissOrTimeOut);
};
const reset = () => {
  return getToast().reset();
};
const success = (messageTitle, messageContent, userDismissOrTimeOut) => {
  return notify(messageTitle, messageContent, 'success', userDismissOrTimeOut);
};
const info = (messageTitle, messageContent, userDismissOrTimeOut) => {
  return notify(messageTitle, messageContent, 'info', userDismissOrTimeOut);
};
const error = (messageTitle, messageContent, userDismissOrTimeOut) => {
  return notify(messageTitle, messageContent, 'error', userDismissOrTimeOut);
};
const warning = (messageTitle, messageContent, userDismissOrTimeOut) => {
  return notify(messageTitle, messageContent, 'warning', userDismissOrTimeOut);
};
const toast = {
  notify, reset, success, info, error, warning
};

export { toast as t };
